import React from 'react';
import _ from 'lodash';
import { useUser } from '@lore/auth';
import { PayloadStates } from '@lore/utils';
import queryString from 'query-string';
import { AcademicCapIcon } from '@heroicons/react/24/outline';
import OptionCard from '@/pages/my-network/OptionCard';
import useQuery from '@/pages/people-educators/useQuery';
import useUserTags from '@/hooks/useUserTags';
import TagTypes from '@/constants/TagTypes';
import Loader from '@/components/Loader';

export default function MatchingEducators() {
  const currentUser = useUser();

  const userSubjects = useUserTags(currentUser, TagTypes.Subject);

  const params = {
    search: {
      subjects: userSubjects.data.length > 0 ?
        _.uniq(userSubjects.data.map(userSubject => userSubject._tag.id)).join(',') :
        undefined
    }
  };

  const users = useQuery(params);

  if (
    userSubjects.state === PayloadStates.FETCHING ||
    users.state === PayloadStates.FETCHING
  ) {
    return (
      <Loader />
    );
  }

  if (
    userSubjects.meta?.totalCount === 0 ||
    users.meta?.totalCount === 0
  ) {
    return null;
  }

  return (
    <OptionCard
      count={users.meta?.totalCount}
      // imageUrl={bookshelfImage}
      icon={AcademicCapIcon}
      title="Educators teaching the same subjects you are"
      subtitle="See what projects educators like you are trying!"
      linkText="View"
      to={{
        pathname: '/educators',
        search: queryString.stringify(params.search)
      }}
    />
  );
}
